import { jQuery } from './utils/jquery.js';

jQuery(function ($) {
    var giftWrapInstance = {
        addToGiftWrapBtnEl: $('.js-add-gift-wrap'),
        removeGiftWrapBtnEl: $('.js-remove-gift-wrap'),
        validateGiftWrap: $('.gift-message-form__button'),
        errorCodesEL: $('.js-wagt-add-gift-wrap-msg-wrap'),
        messageArea: $('.gift-message-form__textarea-container'),
        addGiftWrap: function () {
            let data = {
                action: 'wag_add_gift_wrap',
                gift_message: $('.js-gift-message-input').val()
            };
            $.ajax({
                type: 'post',
                url: window['wagt_ajax_url'],
                data: data,
                beforeSend: function (response) {
                    //site_preloader_on();
                    giftWrapInstance.errorCodesEL.hide();
                }, complete: function (response) {
                    //site_preloader_off();
                }, success: function (response) {
                    if (response.succ) {
                        giftWrapInstance.messageArea.hide();
                        giftWrapInstance.removeGiftWrapBtnEl.show();
                        giftWrapInstance.addToGiftWrapBtnEl.hide();
                        giftWrapInstance.errorCodesEL.find('p').html(response.msg);
                        giftWrapInstance.errorCodesEL.show();
                    }
                },
            });
        },
        removeGiftWrap: function() {
            let data = {
                action: 'wag_remove_gift_wrap',
                gift_message: $('.js-gift-message-input').val()
            };

            $.ajax({
                type: 'post',
                url: window['wagt_ajax_url'],
                data: data,
                beforeSend: function (response) {
                    giftWrapInstance.errorCodesEL.hide();
                }, complete: function (response) {
                }, success: function (response) {
                    if (response.succ) {
                        giftWrapInstance.addToGiftWrapBtnEl.show();
                        giftWrapInstance.removeGiftWrapBtnEl.hide();
                        giftWrapInstance.errorCodesEL.find('p').html(response.msg);
                        giftWrapInstance.errorCodesEL.show();
                    }
                },
            });
        },
        showMessageArea: function() {
            giftWrapInstance.errorCodesEL.hide();
            giftWrapInstance.messageArea.show();
        },
        hideMessageArea: function() {
            giftWrapInstance.messageArea.hide();
        }
    };

    $(document).on('click', '.gift-message-form__button', function(e) {
        e.preventDefault();
        giftWrapInstance.addGiftWrap();
    });

    $(document).on('click', '.js-add-gift-wrap', function () {
        giftWrapInstance.showMessageArea();
    });

    $(document).on('click', '.js-add-gift-wrap', function () {
        giftWrapInstance.showMessageArea();
    });

    $(document).on('click', '.js-remove-gift-wrap', function () {
        giftWrapInstance.removeGiftWrap();
    });

    $(document.body).on('updated_wc_div', function() {
        giftWrapInstance.addToGiftWrapBtnEl = $('.js-add-gift-wrap');
        giftWrapInstance.removeGiftWrapBtnEl = $('.js-remove-gift-wrap');
        giftWrapInstance.validateGiftWrap = $('.gift-message-form__button');
        giftWrapInstance.errorCodesEL = $('.js-wagt-add-gift-wrap-msg-wrap');
        giftWrapInstance.messageArea = $('.gift-message-form__textarea-container');
    });

}, (jQuery));
